import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";

@Component({
	selector: 'unos-status-stip',
	templateUrl: './unos-status-stip.component.html',
	styleUrls: ['./unos-status-stip.component.css']
})
export class UnosStatusStipComponent implements OnInit {
	@Input() id;
	@Input() idTipa;
	@Input() prijave;
	@Input()jedinice : any = [];
	@Input()statusi : any = [];

	@Output() onInsertStatus = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	loading = false;
	msg : any;
	naziv : any = null; 
	odPos : any = null; 
	doPos : any = null; 
	idStatusa : any = null; 

	err_odPos = false;
	err_odPos_poruka = '';
	err_doPos = false;
	err_doPos_poruka = '';
	err_idJedinice = false;
	err_idJedinice_poruka = '';
	err_idStatusa = false;
	err_idStatusa_poruka = '';

	

	ngOnInit() {
		//this.ucitaj();
	}

	ngAfterViewInit() {
		//console.log('ngAfterViewInit');
	}
	server_data : any = null;
	toastTimeout = 5000;

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	savedata(){
		if (!this.odPos) {
			this.err_odPos = true;
			this.err_odPos_poruka = 'Morate definisati polje Od pozicije.';
			M.toast({html: this.err_odPos_poruka, displayLength : this.toastTimeout});
			return;
		}

		if (!this.globalSrvc.CheckInt(this.odPos)){
			this.err_odPos = true;
			this.err_odPos_poruka = 'Nevalidan format za polje Od pozicije. Zadajte cio broj';
			M.toast({html: this.err_odPos_poruka, displayLength : this.toastTimeout});
			return;
		}

		let odPosIntVal = parseInt(this.odPos);
		
		if (odPosIntVal < 1 || odPosIntVal > this.prijave.length){
			this.err_odPos = true;
			this.err_odPos_poruka = 'Nevalidna vrijednost za polje Od pozicije. Zadajte broj između 1 i ' + this.prijave.length;
			M.toast({html: this.err_odPos_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_odPos = false;
		this.err_odPos_poruka = '';

		if (!this.doPos) {
			this.err_doPos = true;
			this.err_doPos_poruka = 'Morate definisati polje Do pozicije.';
			M.toast({html: this.err_doPos_poruka, displayLength : this.toastTimeout});
			return;
		}

		if (!this.globalSrvc.CheckInt(this.doPos)){
			this.err_doPos = true;
			this.err_doPos_poruka = 'Nevalidan format za polje Do pozicije. Zadajte cio broj';
			M.toast({html: this.err_doPos_poruka, displayLength : this.toastTimeout});
			return;
		}

		let doPosIntVal = parseInt(this.doPos);
		
		if (doPosIntVal < 1 || doPosIntVal > this.prijave.length){
			this.err_doPos = true;
			this.err_doPos_poruka = 'Nevalidna vrijednost za polje Do pozicije. Zadajte broj između 1 i ' + this.prijave.length;
			M.toast({html: this.err_doPos_poruka, displayLength : this.toastTimeout});
			return;
		}

		if (doPosIntVal < odPosIntVal){
			this.err_doPos = true;
			this.err_doPos_poruka = 'Nevalidna vrijednost za polje Do pozicije. Zadati broj mora biti veći od Od pozicije';
			M.toast({html: this.err_doPos_poruka, displayLength : this.toastTimeout});
			return;
		}

		this.err_odPos = false;
		this.err_odPos_poruka = '';

		if (!this.idStatusa) {
			this.err_idStatusa = true;
			this.err_idStatusa_poruka = 'Morate definisati polje Status.';
			M.toast({html: this.err_idStatusa_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_idStatusa = false;
		this.err_idStatusa_poruka = '';

		let statusInfo = {kandidati : [], idStatusa : this.idStatusa, odPos : 0, doPos : 0 };
		statusInfo.kandidati = this.prijave.map((item) => { return {'id' : item.id, 'naziv' : ''}});		
		statusInfo.idStatusa = this.idStatusa; 
		statusInfo.odPos = odPosIntVal; 
		statusInfo.doPos = doPosIntVal; 
		let url = 'prijave/stip/statusi/postavi';
		/*if (this.id){
			url = 'vlasnici/pravno/izmijeni';
		}*/

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, statusInfo)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;

					if (this.msg.id == 1) {
						if (this.onInsertStatus)
							this.onInsertStatus.emit(statusInfo);
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : this.toastTimeout});
					}
					this.naziv = '';
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}

}
